import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function PublicRoute({ children }) {
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);
  const isPasswordExpired = useSelector(
    (state) => state.accountReducer.currentUser?.password_expired
  );
  const location = useLocation();

  if (isPasswordExpired && location?.pathname === '/login') {
    return children;
  }

  if (isLoggedIn) {
    return <Navigate to='/' replace />;
  }

  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.any,
};

export default memo(PublicRoute);
